import React, {useMemo} from "react"
import {createMuiTheme, ThemeProvider, ThemeProviderProps, responsiveFontSizes, Theme as DefaultTheme, ThemeOptions} from "@material-ui/core";
import {blue, indigo} from "@material-ui/core/colors";
import {useThemeMode} from "../hooks/system/useThemeMode";
import {ThemeProvider as StyledThemeProvider} from 'styled-components'
type P = Omit<ThemeProviderProps, 'theme'>

const THEME: string | undefined = process.env.REACT_APP_THEME

export const Theme = ({children, ...rest}: P) => {
  const {isDarkMode} = useThemeMode();

  const theme = useMemo(() => {
    var styles: ThemeOptions;
    switch(THEME?.toLowerCase()) {
      case 'abra': {
        styles = {
          palette: {
            primary: {
              light: '#6F2ACD',
              main: '#4A148C',
              dark: '#29034E',
            },
            secondary: {
              light: '#A7B3CC',
              main: '#22CAFB',
              dark: '#2A7AB0',
            },
            type: 'light',
            contrastThreshold: 2,
            background: {
              default: '#FFF',  //'#8E66EF',
              paper: '#EDF1F3', //'#FFF'
            }
          },
          typography: {
            h1: {fontSize: '4rem', fontFamily: 'proxima-nova'},
            h2: {fontSize: '3.5rem', fontFamily: 'proxima-nova'}
          }
        }
        break;
      }
      case 'uberstate': {
        styles = {
          palette: {
            primary: {
              light: '#348fdf',
              main: '#1E73BE',  // Blue
              dark: '#185c98',
            },
            secondary: {
              main: '#D4AF37', // Gold
              // light: '#494949',
              // main: '#3A3A3A',  // Grey
              // dark: '#2e2e2e',
            },
            type: 'light',
            contrastThreshold: 2,
            background: {
              default: '#F1F1F1',
              paper: '#F5F5F5',  // Off-white
            }
          },
          typography: {
            h1: {fontSize: '4rem', fontFamily: 'Poppins, sans-serif'},
            h2: {fontSize: '3.5rem', fontFamily: 'Poppins, sans-serif'},
            h4: {fontSize: '3rem', fontFamily: 'Poppins, sans-serif'},
            h5: {fontSize: '2.5rem', fontFamily: 'Poppins, sans-serif'},
          }
        }
        break;
      }
      default: {
        styles = {
          palette: {
            primary: indigo,    //isDarkMode ? blue : indigo,
            secondary: indigo,  //isDarkMode ? blue : indigo,
            type: 'light'       //isDarkMode ? 'dark' : 'light',
          },
          typography: {
            h1: {fontSize: '4rem'},
            h2: {fontSize: '3.5rem'},
          }
        }
        break;
      }
    }
    return responsiveFontSizes(createMuiTheme(styles));
  }, [isDarkMode]);

  return (
    <>
    {theme && <StyledThemeProvider theme={theme}>
      <ThemeProvider theme={theme} children={children} {...rest} />
    </StyledThemeProvider>}
    </>
  )
}

export function theme(p: any): DefaultTheme {
  return p.theme
}